import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// Single place to register dayjs plugins used app-wide. Import dayjs from
// here (`import dayjs from "src/dayjsSetup"`) wherever plugin-dependent
// methods (.tz(), .calendar(), etc.) are needed, instead of importing the
// bare "dayjs" package directly — module caching means the plugins are
// only registered once regardless of how many files import this.
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(calendar);
dayjs.extend(customParseFormat);

export default dayjs;
